import React, {Fragment} from "react";

import AnalyticsContext from "./AnalyticsContext";
import {Col, Row} from "reactstrap";

import {formatDate} from "../common/TimeUtil";
import withFilter from "./SiteWithFilter";
import {mergeFilters} from "./Filters/FilterLogic";
import withURLParams from "../common/SiteWithUrlParams";
import Rating_PieChart from "./Components/Rating_Pie";
import Rating_BarChart from "./Components/Rating_Bar";

class RatingsPage extends React.Component {
    constructor(_props) {
        super(_props);

        this.state = {
            updateCounter : 0
        };

    }

    render() {
        let gameId = this.props.urlParams.gameId;
        let comp = 0;
        let getKey = () => {
            const id = comp;
            comp +=1;
            return "comp_"+id+"_"+this.state.updateCounter;
        };

        const startDate = formatDate(this.props.dateSelection.start);
        const endDate = formatDate(this.props.dateSelection.end);



        const filter = mergeFilters(this.props.filter, {game_id : gameId});

        return (
            <Fragment>
                <Row>
                    <Col lg={ 3} md={ 6 } className="mt-3">
                        <Rating_BarChart key={getKey()} startDate={startDate} endDate={endDate} group={this.props.group} filter={filter} withSum/>
                    </Col>
                    <Col lg={ 3} md={ 6 } className="mt-3">
                        <Rating_PieChart key={getKey()} title="organic" startDate={startDate} endDate={endDate} filter={mergeFilters(filter, {ua_type:"organic"})}/>
                    </Col>
                    <Col lg={ 3} md={ 6 } className="mt-3">
                        <Rating_PieChart key={getKey()} title="non-organic" startDate={startDate} endDate={endDate} filter={mergeFilters(filter, {ua_type:"non-organic"})}/>
                    </Col>
                </Row>
            </Fragment>
        );
    }
}

export default withURLParams(withFilter(RatingsPage, ["filter","time","group"],(_props)=> {return "Rating: "+AnalyticsContext.getGameName(_props.urlParams.gameId);}));